<template>
    <div class="flex items-center justify-center h-screen">
        <vs-row vs-justify="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
                <vs-card>
                <div slot="header">
                    <h3>
                        Area 51 restringida
                    </h3>
                </div>
                <div>
                    <span>No tienes la autorización para poder visualizar el contenido.</span>
                </div>
                <div slot="footer">
                    <vs-row vs-justify="flex-end">
                        <vs-button color="primary" @click="regresar">Regresar</vs-button>
                    </vs-row>
                </div>
                </vs-card>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js'; 
    import {mapState} from 'vuex';
    export default {
        data() {
            return {
                timer: 3
            }
        },
        computed: {
            ...mapState(['domain', 'informationPage'])
        },
        methods: {
            regresar(){
                history.back();
            },
            redireccionar(){
                if(!this.domain.domainName){
                    this.timer--;
                    if(this.timer > 0){
                        setTimeout(this.redireccionar,1000);
                    }
                    if(this.timer == 0){
                        MetodosGenerales.cerrarSesion(this.domain.domainNameForApi, this.informationPage);
                    }
                }
            }
        },
        // mounted() {
        //     if(!this.domain.domainName){
        //         setTimeout(this.redireccionar,1000);
        //     }
        // },
    }
</script>